export default "__VITE_ASSET__qh62zO4I__"